import React, { Component } from 'react';

/**
 * Error boundary specifically for the main booking page to prevent
 * constant refreshing due to map loading issues.
 */
class BookingErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.errorCount = 0;
    this.maxErrors = 3; // Maximum number of errors before stopping refresh cycle
    this.lastErrorTime = 0;
    this.errorTimeWindow = 5000; // 5 seconds
  }

  componentDidMount() {
    // KEEP IT SIMPLE - No error handling to match standalone page behavior
    console.log('Keeping error boundary simple - no error handling like standalone page');
  }

  componentWillUnmount() {
    // Cleanup any listeners or overrides if needed
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.log('BookingPage error caught by boundary:', error, errorInfo);
    
    // Implement error throttling to prevent refresh loops
    const now = Date.now();
    if (now - this.lastErrorTime < this.errorTimeWindow) {
      this.errorCount++;
    } else {
      this.errorCount = 1;
    }
    this.lastErrorTime = now;

    // Log severe error conditions but don't refresh
    if (this.errorCount > this.maxErrors) {
      console.log('Too many errors in booking page, stopping refresh cycle');
    }
  }

  render() {
    if (this.state.hasError && this.errorCount > this.maxErrors) {
      // Show fallback UI after too many errors
      return (
        <div className="p-8 text-center">
          <h2 className="text-2xl text-white mb-4">Something went wrong loading the booking form</h2>
          <p className="mb-4 text-gray-300">Please try refreshing the page or contact support if the problem persists.</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-white text-black rounded-md hover:bg-gray-200"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    // Normally, just render children
    return this.props.children;
  }
}

export default BookingErrorBoundary; 